import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { actionClearMessage } from '../../../redux-flow/actions/contratos'
import { Button, Empty, Icon, Modal, Upload, Tooltip, Input } from 'antd'
import moment from 'moment'
import { API_URL, request, getInfoLocalStorage } from '../../../utils/api'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import attach from '../../../images/attach.png'
import NoIndicacao from '../../../images/sem-contrato.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom'
import { maskCpf } from '../../../utils/masks'

const { Dragger } = Upload;

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

const NovaIndicacaoBtn = () => (
    <div className="novoContrato mt-3">
        <Link to="/indicacoes/nova">
            <button type="button" className="btnGrafico">
                Nova Indicação
            </button>
        </Link>
    </div>
)

const DocumentosBtn = () => (
    <div className="novoContrato mt-3">
        <Link to="/minhaconta">
            <button type="button" className="btnGrafico">
                Meus Documentos
            </button>
        </Link>
    </div>
)

const PermissaoBtn = (props) => (
    <div className="novoContrato mt-3">
        <button type="button" className="btnGrafico" onClick={props.onClick}>
            Solicitar Permissão
        </button>
    </div>
)

const NovaIndicacaoBtnDisabled = () => (
    <div className="novoContratoDisabled mt-3">
        <Tooltip title="Por favor, verifique seus documentos.">
            <button type="button" className="btnGrafico">
                Nova Indicação
            </button>
        </Tooltip>
    </div>
)

const NoIndicacoes = (props) => (
    <div className="noContracts">
        <Container>
            <Row>
                <Col md={12}>
                    <div className="noContractsWrapper">
                        <img src={NoIndicacao} alt="Sem indicações" />
                        <h3>Você ainda não possui indicações</h3>
                        <p>Indique amigos e familiares para nossos produtos de investimento e ganhe recompensas!</p>
                        {props.permissao === 1 ? <NovaIndicacaoBtnDisabled /> : props.nivelVerificacao === 111 ? <NovaIndicacaoBtn /> : <DocumentosBtn />}
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
)

class ContratoWrapper extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            modalOpened: false,
            modalAporteOpened: false,
            modalRenovacaoOpened: false,
            modalDocOpened: false,
            fileList: [],
            uploading: false,
            uploadSuccess: false,
            uploadError: false,
            errorMessage: '',
            successMessage: '',
            tipoAporte: 0,
            tipoRenovacao: 0,
            tipoContrato: 0,
            dataGrafico: [],
            labelGrafico: [],
            datasetGrafico: [],
            datasetGraficoRentabilidade: [],
            datasetGraficoRentabilidadeAcumulada: [],
            datasetGraficoRentabilidadeAcumuladaTotal: [],
            datasetGraficoRentabilidadeTotal: [],
            datasetGraficoRentabilidadeMensal: [],
            datasetGraficoRentabilidadeMensalTotal: [],
            datasetGraficoRentabilidadeMensalAcumulada: [],
            datasetGraficoRentabilidadeMensalAcumuladaTotal: [],
            filtroGrafico: 'rentabilidade',
            filtroGraficoTempo: 'mensal',
            filtroGraficoAcumulado: false,
            filtroGraficoTotal: false,
        }
    }

    closeModal = () => {
        this.setState({ modalOpened: false })
    }

    closeModalAporte = () => {
        this.setState({ modalAporteOpened: false })
        this.props.onLoad(this.props.userid)
    }

    closeModalRenovacao = () => {
        this.setState({ modalRenovacaoOpened: false })
        this.props.onLoad(this.props.userid)
    }

    closeModalDoc = () => {
        this.setState({ modalDocOpened: false })
        this.props.onLoad(this.props.userid)
    }

    openModalDocumento = (e) => {
        e.preventDefault()
        this.setState({ modalDocOpened: true })
    }

    componentDidMount() {
        if (this.props.indicacao && this.props.indicacao.id) {
            this.gerarGrafico()
        }
    }

    render() {
        const { indicacao, user, permissao, onPermissao, userid, isLoading, success, message } = this.props
        const { fileList, uploading, uploadSuccess, uploadError, errorMessage, successMessage } = this.state

        if (!indicacao || !indicacao.id) {
            return <NoIndicacoes permissao={permissao} nivelVerificacao={user && user.nivelVerificacao ? user.nivelVerificacao : ''} />
        }

        return (
            <div className="contratoWrapper">
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className="contratoHeader">
                                <h3>Detalhes da Indicação</h3>
                                <div className="contratoStatus">
                                    <span className={`status-${indicacao.status}`}>
                                        {indicacao.status === 1 ? 'Ativa' : 
                                         indicacao.status === 2 ? 'Pendente' : 
                                         indicacao.status === 3 ? 'Aprovada' : 
                                         indicacao.status === 4 ? 'Rejeitada' : 
                                         indicacao.status === 5 ? 'Cancelada' : 
                                         indicacao.status === 6 ? 'Convertida' : 'Desconhecido'}
                                    </span>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <div className="contratoInfo">
                                <h4>Informações da Indicação</h4>
                                <ul>
                                    <li>
                                        <span>Nome:</span>
                                        <span>{indicacao.nome}</span>
                                    </li>
                                    <li>
                                        <span>Email:</span>
                                        <span>{indicacao.email}</span>
                                    </li>
                                    <li>
                                        <span>Telefone:</span>
                                        <span>{indicacao.telefone}</span>
                                    </li>
                                    <li>
                                        <span>Data da Indicação:</span>
                                        <span>{moment(indicacao.dataIndicacao).format('DD/MM/YYYY')}</span>
                                    </li>
                                    {indicacao.status === 6 && (
                                        <li>
                                            <span>Data de Conversão:</span>
                                            <span>{moment(indicacao.dataConversao).format('DD/MM/YYYY')}</span>
                                        </li>
                                    )}
                                    {indicacao.recompensa && (
                                        <li>
                                            <span>Recompensa:</span>
                                            <span>R$ {indicacao.recompensa.toFixed(2).replace('.', ',')}</span>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="contratoInfo">
                                <h4>Status da Indicação</h4>
                                <div className="statusIndicacao">
                                    <div className={`statusStep ${indicacao.status >= 1 ? 'active' : ''}`}>
                                        <div className="statusIcon">1</div>
                                        <div className="statusText">Indicação Enviada</div>
                                    </div>
                                    <div className={`statusStep ${indicacao.status >= 2 ? 'active' : ''}`}>
                                        <div className="statusIcon">2</div>
                                        <div className="statusText">Contato Realizado</div>
                                    </div>
                                    <div className={`statusStep ${indicacao.status >= 3 ? 'active' : ''}`}>
                                        <div className="statusIcon">3</div>
                                        <div className="statusText">Interesse Confirmado</div>
                                    </div>
                                    <div className={`statusStep ${indicacao.status >= 6 ? 'active' : ''}`}>
                                        <div className="statusIcon">4</div>
                                        <div className="statusText">Investimento Realizado</div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    
})

const mapDispatchToProps = (dispatch) => ({
    onClearMessage: () => {
        dispatch(actionClearMessage())
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(ContratoWrapper) 